import React from 'react';
import { connect } from 'react-redux';
import PlaidLink from 'react-plaid-link';

import * as billingActions from '../../redux/billing';
import { PLAID_PUBLIC_KEY, ENV_NAME } from '../../services/constants';

interface Props {
  addAccount: Function;
  changePage: Function;
}

interface State {
  addingAccount: boolean;
  inPicker: boolean;
}

class AddBankAccount extends React.Component<Props, State> {
  myRef: any;
  constructor(props) {
    super(props);
    this.handleOnSuccess = this.handleOnSuccess.bind(this);
    this.state = { addingAccount: false, inPicker: false };
    this.myRef = React.createRef();
  }

  handleOnLoad() {
    this.myRef.current.linkHandler.open();
  }

  handleOnSuccess(token, metadata) {
    this.setState({ addingAccount: true });
    this.props.addAccount(token, metadata, '/billing/added');
  }

  event(e: any, _) {
    if (e === 'SELECT_INSTITUTION') this.setState({ inPicker: true });
  }

  render() {
    return (
      <div>
        {this.state.addingAccount ? null : (
          <PlaidLink
            clientName="Neon Coat"
            env={ENV_NAME === 'production' ? 'development' : 'sandbox'}
            product={['auth', 'transactions']}
            publicKey={PLAID_PUBLIC_KEY}
            className="col paymentItemName btn"
            style={{ display: 'none' }}
            selectAccount
            onEvent={(e, m) => this.event(e, m)}
            onSuccess={this.handleOnSuccess}
            onExit={() => this.props.changePage('/billing/methods')}
            onLoad={() => this.handleOnLoad()}
            ref={this.myRef}
          >
            Add bank account
          </PlaidLink>
        )}
        {this.state.inPicker && (
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: '50%',
              margin: '0 auto',
              fontFamily: 'BrandonGrotesque-Regular',
              fontSize: '25px',
            }}
          >
            <div> Linking bank account... </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ billing }) => ({ billing });

export default connect(mapStateToProps, billingActions)(AddBankAccount);
